import { render, staticRenderFns } from "./context-menu.vue?vue&type=template&id=427fc14a&scoped=true&"
import script from "./context-menu.vue?vue&type=script&lang=js&"
export * from "./context-menu.vue?vue&type=script&lang=js&"
import style0 from "./context-menu.vue?vue&type=style&index=0&id=427fc14a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427fc14a",
  null
  
)

export default component.exports